import axios from 'axios';

// Use environment variable for API base URL
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Create axios instance with base URL
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Synchronisations read every record from AIA and upsert them, so they run for far
 * longer than an ordinary request. Under the default ceiling the browser gave up
 * while the server was still working: the page reported a failure for a sync that
 * went on to succeed, which is worse than being slow.
 */
const SYNC_TIMEOUT_MS = 10 * 60 * 1000;

api.interceptors.request.use((config) => {
  // Note the trailing slash: `/api/sync-logs` is an ordinary, fast read and must
  // keep the default ceiling.
  if (config.url?.startsWith('/api/sync/')) {
    config.timeout = SYNC_TIMEOUT_MS;
  }
  return config;
});

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('API response error:', error);
    return Promise.reject(error);
  }
);

export default api;
